import React from 'react';
import { ButtonlikeSize, ButtonlikeVariant, ButtonlikeWidth } from '../types';
import { useButtonClasses } from '../use-button-classes';
import { NavLink, NavLinkProps } from './nav-link';

interface PrimaryLinkProps
  extends Omit<NavLinkProps, 'className' | 'size' | 'usage' | 'variant'> {
  variant?: ButtonlikeVariant;
  size?: ButtonlikeSize;
  width?: ButtonlikeWidth;
}

const PrimaryLink = React.forwardRef<HTMLAnchorElement, PrimaryLinkProps>(
  function PrimaryLinkWithRef(
    {
      size = 'size.md',
      variant = 'variant.base',
      width = 'width.unset',
      ...delegated
    },
    ref
  ) {
    return (
      <NavLink
        {...delegated}
        className={useButtonClasses({
          size,
          usage: 'usage.primary',
          variant,
          width
        })}
        ref={ref}
      />
    );
  }
);

export type { PrimaryLinkProps };
export { PrimaryLink };
